// formSlice.ts
import { RootState } from "@/src-refactor/modules/store/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useCallback } from "react";

interface FormState {
  currentStep: number;
}

const initialState: FormState = {
  currentStep: 0
};

export const FormPropertySlice = createSlice({
  name: "FormPropertySlice",
  initialState,
  reducers: {
    updateStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    resetFormPropertyState: () => initialState // Add reset reducer
  }
});

export const { updateStep, resetFormPropertyState } = FormPropertySlice.actions; // Export the reset action
export default FormPropertySlice.reducer;

import { useDispatch, useSelector } from "react-redux";

export const useFormPropertySlice = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector(
    (state: RootState) => state.FormPropertySlice.currentStep
  );

  const setStep = useCallback(
    (step: number) => {
      dispatch(updateStep(step));
    },
    [dispatch]
  );
  const getCurrentStep = useCallback(() => {
    return currentStep;
  }, [currentStep]);

  return { currentStep, setStep, getCurrentStep } as {
    currentStep: number;
    setStep: (step: number) => void;
    getCurrentStep: () => number;
  };
};

export const useResetFormPropertyState = () => {
  const dispatch = useDispatch();
  return () => dispatch(resetFormPropertyState());
};
